import { inject, Injectable } from '@angular/core';
import { AppleApplicationStoreActions, AppleApplicationStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { first, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppleApplicationResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(AppleApplicationStoreSelectors.selectAppleApplicationsLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(AppleApplicationStoreActions.AppleApplicationResolverActions.applicationsRequested());
        }
      }),
      first()
    );
  }
}
